

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Project
import { TestimonialContentNode } from "~/libs/Types";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component Properties ----------------------------------------------------

    props: {
        item: {
            type: Object as () => TestimonialContentNode,
            required: true
        }
    },

    // Component Computed Properties -------------------------------------------

    computed: {
        hasImage (): boolean {
            return !!this.item.image;
        },

        imagePath (): string {
            return this.item.image ?? "";
        },

        hasfieldOfStudy (): boolean {
            return !!this.item.field?.primary || !!this.item.field?.secondary;
        }
    }

    // -------------------------------------------------------------------------
});

